import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { Button, message, Spin } from 'antd';
import { graphql } from 'react-apollo';
import MuiButton from 'material-ui/Button';
import localForage from 'localforage';
import MuiIconButton from 'material-ui/IconButton';
import DeleteIcon from '@material-ui/icons/Delete';
import BizSelect from '../../components/UI/BizSelect';
import BizCard from '../../components/UI/BizCard';
import BizInput from '../../components/UI/BizInput';
import SaveBtn from '../../components/SaveButton';

import { currencyFormat, financialSummaryEntries } from '../../utils/globals';

import createFactsheetDataQuery from '../../graphql/queries/createFactsheetDataQuery.graphql';

const DeleteFormRowButton = (props) => (
  <MuiIconButton
    aria-label="Delete"
    onClick={props.onClick}
    style={{ width: 30, height: 30 }}
  >
    <DeleteIcon />
  </MuiIconButton>
);
DeleteFormRowButton.propTypes = {
  onClick: PropTypes.func.isRequired,
};

const initialState = {
  current_proposal: [],
  current_proposal_note: '',
  current_proposal_intro: '',
  companyName: '',
  cin: '',
  registeredAddress: '',
  factoryAddress: '',
  lineOfActivity: '',
  capacity: [],
  proposedProject: '',
  companyBackground: '',
  promoters: [],
  groupBackground: '',
  projectBackground: '',
  projectCurrentStatus: '',
  projectSwotAnalysis: '',
  financialSummary: {
    fs1: [0, 0, 0],
    fs2: [0, 0, 0],
    fs3: [0, 0, 0],
    fs4: [0, 0, 0],
    fs5: [0, 0, 0],
    fs6: [0, 0, 0],
    fs7: [0, 0, 0],
    fs8: [0, 0, 0],
    fs9: [0, 0, 0],
    fs10: [0, 0, 0],
    fs11: [0, 0, 0],
    fs12: [0, 0, 0],
    fs13: [0, 0, 0],
    fs14: [0, 0, 0],
    fs15: [0, 0, 0],
    fs16: [0, 0, 0],
    fs17: [0, 0, 0],
    fs18: [0, 0, 0],
    fs19: [0, 0, 0],
    fs20: [0, 0, 0],
    fs21: [0, 0, 0],
  },
  proposedBanking: [],
  bankersNote: '',
  securityPrimaryImmovable: [],
  securityPrimaryMovable: [],
  securityCollateralImmovable: [],
  securityCollateralMovable: [],
};

const localForageItemkey = (cid) => `Customer-${cid}_FactsheetSavedData`;

const styles = {
  labelHead: { fontWeight: 700, margin: '5px 0', fontSize: 14 },
  tableTopBottomFilled: { margin: '10px 0' },
  sectionHeadRow: {},
  sectionHead: {
    fontWeight: 700,
    margin: 0,
  },
};

const currentYear = new Date().getFullYear();
// const years = [];
// for (let i = 3; i > 0; i--) {
//   years.push(currentYear - i);
// }

const natureOfChargeOptions = [
  { label: 'First & Exclusive', value: 'First & Exclusive' },
  { label: 'Pari passu', value: 'Pari passu' },
  { label: 'First & Pari passu', value: 'First & Pari passu' },
  { label: 'Second', value: 'Second' },
  { label: 'Second & Pari passu', value: 'Second & Pari passu' },
];

class FactsheetCreate extends Component {
  state = { ...initialState };

  componentDidMount() {
    localForage.getItem(localForageItemkey(this.props.match.params.id))
      .then((value) => {
        if (value) {
          this.setState({
            ...value,
          });
        }
      });
  }

  saveData = () => {
    const { ...data } = this.state;
    localForage.setItem(localForageItemkey(this.props.match.params.id), data)
      .then(() => {
        message.success('Saved!');
      })
      .catch(() => {
        message.error('Not Saved!');
      });
  };

  handleFormValue = (key, value) => {
    this.setState({
      [key]: value,
    });
  };

  handleArrayFormValue = (arrayName, id, key, value) => {
    this.setState({
      [arrayName]: this.state[arrayName].map((entry) => {
        const newEntry = entry;
        if (newEntry.id === id) newEntry[key] = value;
        return newEntry;
      }),
    });
  };

  removeFormRow = (stateObjKey, id) => {
    this.setState({
      [stateObjKey]: this.state[stateObjKey].filter((entry) => (entry.id !== id)),
    });
  };

  handleFinancialSummaryValues = (key, index, value) => {
    this.setState({
      financialSummary: {
        ...this.state.financialSummary,
        [key]: this.state.financialSummary[key].map((entry, entriesIndex) => {
          if (entriesIndex === index) return value;
          return entry;
        }),
      },
    });
  };

  financialSummaryRow = ({ noValue, id, name }) => {
    const { financialSummary } = this.state;
    if (noValue) {
      return (
        <tr key={id}>
          <th colSpan={4} style={{ paddingLeft: 10 }}>{name}</th>
        </tr>
      );
    }
    return (
      <tr key={id}>
        <td>{name}</td>
        <td>
          <BizInput
            type="number"
            theme="lac"
            name={`${id}[0]`}
            onChange={(value) => { this.handleFinancialSummaryValues(id, 0, value); }}
            value={financialSummary[id][0]}
          />
        </td>
        <td>
          <BizInput
            type="number"
            theme="lac"
            name={`${id}[1]`}
            onChange={(value) => { this.handleFinancialSummaryValues(id, 1, value); }}
            value={financialSummary[id][1]}
          />
        </td>
        <td>
          <BizInput
            type="number"
            theme="lac"
            name={`${id}[2]`}
            onChange={(value) => { this.handleFinancialSummaryValues(id, 2, value); }}
            value={financialSummary[id][2]}
          />
        </td>
      </tr>
    );
  };

  render() {
    if (this.props.data.loading) {
      return <Spin size="large" />;
    }

    const {
      current_proposal,
      current_proposal_note,
      current_proposal_intro,
      companyName,
      cin,
      registeredAddress,
      factoryAddress,
      lineOfActivity,
      capacity,
      proposedProject,
      companyBackground,
      promoters,
      groupBackground,
      projectBackground,
      projectCurrentStatus,
      projectSwotAnalysis,
      proposedBanking,
      bankersNote,
      securityPrimaryImmovable,
      securityPrimaryMovable,
      securityCollateralImmovable,
      securityCollateralMovable,
    } = this.state;

    const {
      details,
      present_banking_arrangements,
      group_name,
    } = this.props.data.createFactsheetData;

    let totalCurrentProposal = 0;
    current_proposal.forEach((entry) => {
      totalCurrentProposal += entry.amount;
    });

    return (
      <div className="container-fluid" style={{ paddingTop: 20 }}>
        <BizCard title="Edit Factsheet">
          <SaveBtn handleSave={this.saveData} />
          <table className="biz-form-table">
            <tbody>
              {/* Current Proposal */}
              <tr style={styles.sectionHeadRow}>
                <td colSpan={3}><h5 style={styles.sectionHead}>Current Proposal</h5></td>
              </tr>
              <tr>
                <td className="biz-form-table-label">Introduction</td>
                <td className="biz-form-table-input">
                  <BizInput
                    type="textarea"
                    theme="lac"
                    name="current_proposal_intro"
                    onChange={(value) => { this.handleFormValue('current_proposal_intro', value); }}
                    value={current_proposal_intro}
                    style={{ width: '100%', height: 80, maxWidth: 'unset' }}
                  />
                </td>
                <td className="biz-form-table-action" />
              </tr>
              <tr>
                <td className="biz-form-table-label">Current Proposal</td>
                <td className="biz-form-table-input">
                  <table className="biz-data-table biz-bordered">
                    <thead>
                      <tr>
                        <th>Particulars</th>
                        <th>Amount</th>
                        <th>Tenure</th>
                        <th>Expected ROI</th>
                        <th />
                      </tr>
                    </thead>
                    <tbody>
                      {
                        current_proposal.map((cp) => (
                          <tr key={cp.id}>
                            <td>
                              <BizInput
                                theme="lac"
                                name={`current_proposal[${cp.id}][name]`}
                                onChange={(value) => { this.handleArrayFormValue('current_proposal', cp.id, 'name', value); }}
                                value={cp.name}
                              />
                            </td>
                            <td>
                              <BizInput
                                theme="lac"
                                type="number"
                                name={`current_proposal[${cp.id}][amount]`}
                                onChange={(value) => { this.handleArrayFormValue('current_proposal', cp.id, 'amount', value); }}
                                value={cp.amount}
                              />
                            </td>
                            <td>
                              <BizInput
                                theme="lac"
                                type="textarea"
                                name={`current_proposal[${cp.id}][tenure]`}
                                onChange={(value) => { this.handleArrayFormValue('current_proposal', cp.id, 'tenure', value); }}
                                value={cp.tenure}
                                textareaRows={2}
                              />
                            </td>
                            <td>
                              <BizInput
                                theme="lac"
                                name={`current_proposal[${cp.id}][roi]`}
                                onChange={(value) => { this.handleArrayFormValue('current_proposal', cp.id, 'roi', value); }}
                                value={cp.roi}
                              />
                            </td>
                            <td>
                              <DeleteFormRowButton onClick={() => { this.removeFormRow('current_proposal', cp.id); }} />
                            </td>
                          </tr>
                        ))
                      }
                      <tr>
                        <th style={{ textAlign: 'right', paddingRight: 5 }}>Total</th>
                        <th style={{ textAlign: 'right', paddingRight: 5 }}>{currencyFormat(totalCurrentProposal)}</th>
                        <td colSpan={3} />
                      </tr>
                    </tbody>
                  </table>
                </td>
                <td className="biz-form-table-action">
                  <Button
                    onClick={() => {
                      this.setState({
                        current_proposal: [...current_proposal, {
                          id: (+new Date()).toString(36),
                          name: '',
                          amount: 0,
                          tenure: '',
                          roi: '',
                        }],
                      });
                    }}
                  >
                    Add new proposal
                  </Button>
                </td>
              </tr>
              <tr>
                <td className="biz-form-table-label">Notes</td>
                <td className="biz-form-table-input">
                  <BizInput
                    type="textarea"
                    theme="lac"
                    name="current_proposal_note"
                    onChange={(value) => { this.handleFormValue('current_proposal_note', value); }}
                    value={current_proposal_note}
                    style={{ width: '100%', height: 150, maxWidth: 'unset' }}
                  />
                </td>
                <td className="biz-form-table-action" />
              </tr>

              {/* **
              Company Background
            ** */}
              <tr style={styles.sectionHeadRow}>
                <td colSpan={3}><h5 style={styles.sectionHead}>Company Background</h5></td>
              </tr>
              {/* Company Name */}
              <tr>
                <td className="biz-form-table-label">Company Name</td>
                <td className="biz-form-table-input">{companyName}</td>
                <td className="biz-form-table-action" />
              </tr>
              {/* CIN */}
              <tr>
                <td className="biz-form-table-label">CIN</td>
                <td className="biz-form-table-input">
                  <BizInput
                    theme="lac"
                    name="cin"
                    onChange={(value) => { this.handleFormValue('cin', value); }}
                    value={cin}
                  />
                </td>
                <td className="biz-form-table-action" />
              </tr>
              {/* Registered Address */}
              <tr>
                <td className="biz-form-table-label">Registered Address</td>
                <td className="biz-form-table-input">
                  {
                    registeredAddress ?
                      registeredAddress
                      :
                      <BizInput
                        type="textarea"
                        theme="lac"
                        name="registeredAddress"
                        onChange={(value) => { this.handleFormValue('registeredAddress', value); }}
                        value={registeredAddress}
                      />
                  }
                </td>
                <td className="biz-form-table-action" />
              </tr>
              {/* Factory Address */}
              <tr>
                <td className="biz-form-table-label">Factory Address</td>
                <td className="biz-form-table-input">
                  {
                    factoryAddress ?
                      factoryAddress
                      :
                      <BizInput
                        type="textarea"
                        theme="lac"
                        name="factoryAddress"
                        onChange={(value) => { this.handleFormValue('factoryAddress', value); }}
                        value={factoryAddress}
                      />
                  }
                </td>
                <td className="biz-form-table-action" />
              </tr>
              {/* Line of Activity */}
              <tr>
                <td className="biz-form-table-label">Line of Activity</td>
                <td className="biz-form-table-input">
                  <BizInput
                    type="textarea"
                    theme="lac"
                    name="lineOfActivity"
                    onChange={(value) => { this.handleFormValue('lineOfActivity', value); }}
                    value={lineOfActivity}
                  />
                </td>
                <td className="biz-form-table-action" />
              </tr>
              {/* Capacity */}
              <tr>
                <td className="biz-form-table-label">Capacity</td>
                <td className="biz-form-table-input">
                  <table className="biz-data-table biz-bordered">
                    <thead>
                      <tr>
                        <th>Particulars</th>
                        <th>Capacity</th>
                        <th />
                      </tr>
                    </thead>
                    <tbody>
                      {
                        capacity.map((entry) => (
                          <tr key={entry.id}>
                            <td>
                              <BizInput
                                theme="lac"
                                name={`capacity[${entry.id}][name]`}
                                onChange={(value) => { this.handleArrayFormValue('capacity', entry.id, 'name', value); }}
                                value={entry.name}
                              />
                            </td>
                            <td>
                              <BizInput
                                theme="lac"
                                name={`capacity[${entry.id}][capacity]`}
                                onChange={(value) => { this.handleArrayFormValue('capacity', entry.id, 'capacity', value); }}
                                value={entry.capacity}
                              />
                            </td>
                            <td>
                              <DeleteFormRowButton onClick={() => { this.removeFormRow('capacity', entry.id); }} />
                            </td>
                          </tr>
                        ))
                      }
                    </tbody>
                  </table>
                </td>
                <td className="biz-form-table-action">
                  <Button
                    onClick={() => {
                      this.setState({
                        capacity: [...capacity, {
                          id: (+new Date()).toString(36),
                          name: '',
                          capacity: '',
                        }],
                      });
                    }}
                  >
                    Add new capacity
                  </Button>
                </td>
              </tr>
              {/* External Credit Rating */}
              {
                details.external_ratings.length > 0 ?
                  <tr>
                    <td className="biz-form-table-label">External Credit Rating</td>
                    <td className="biz-form-table-input">
                      {
                        details.external_ratings.map((entry) => (
                          <p key={entry.id} style={{ marginBottom: 5 }}>{`${entry.rating} by ${entry.agency}`}</p>
                        ))
                      }
                    </td>
                    <td className="biz-form-table-action" />
                  </tr>
                  :
                  null
              }
              {/* Line of Activity */}
              <tr>
                <td className="biz-form-table-label">Existing Bankers</td>
                <td className="biz-form-table-input">
                  {
                    present_banking_arrangements.map((entry) => (
                      <p key={entry.id} style={{ marginBottom: 5 }}>{entry.bank_name}</p>
                    ))
                  }
                </td>
                <td className="biz-form-table-action" />
              </tr>
              {/* Proposed Project */}
              {
                details.new_project ?
                  <tr>
                    <td className="biz-form-table-label">Proposed Project</td>
                    <td className="biz-form-table-input">
                      <BizInput
                        type="textarea"
                        theme="lac"
                        name="proposedProject"
                        onChange={(value) => { this.handleFormValue('proposedProject', value); }}
                        value={proposedProject}
                        style={{ width: '100%', height: 150, maxWidth: 'unset' }}
                      />
                    </td>
                    <td className="biz-form-table-action" />
                  </tr>
                  :
                  null
              }
              {/* Company Background */}
              <tr>
                <td className="biz-form-table-label">Company Background</td>
                <td className="biz-form-table-input">
                  <BizInput
                    type="textarea"
                    theme="lac"
                    name="companyBackground"
                    onChange={(value) => { this.handleFormValue('companyBackground', value); }}
                    value={companyBackground}
                    style={{ width: '100%', height: 150, maxWidth: 'unset' }}
                  />
                </td>
                <td className="biz-form-table-action" />
              </tr>

              {/* **
              3. Promoter Background
            ** */}
              <tr style={styles.sectionHeadRow}>
                <td colSpan={3}><h5 style={styles.sectionHead}>Promoter Background</h5></td>
              </tr>
              {/* Management Team */}
              <tr>
                <td className="biz-form-table-label">Management Team</td>
                <td className="biz-form-table-input">
                  <table className="biz-data-table biz-bordered">
                    <thead>
                      <tr>
                        <th>Name</th>
                        <th>Qualifications</th>
                        <th>PAN</th>
                        <th>AADHAAR</th>
                        <th>DOB</th>
                        <th>Address</th>
                        <th>Networth</th>
                      </tr>
                    </thead>
                    <tbody>
                      {
                        promoters.map((entry) => (
                          <tr key={entry.id}>
                            <td>{entry.name}</td>
                            <td>
                              <BizInput
                                type="textarea"
                                theme="lac"
                                name={`promoters[${entry.id}][qualifications]`}
                                onChange={(value) => { this.handleArrayFormValue('promoters', entry.id, 'qualifications', value); }}
                                value={entry.qualifications}
                              />
                            </td>
                            <td>
                              <BizInput
                                theme="lac"
                                name={`promoters[${entry.id}][pan]`}
                                onChange={(value) => { this.handleArrayFormValue('promoters', entry.id, 'pan', value); }}
                                value={entry.pan}
                              />
                            </td>
                            <td>
                              <BizInput
                                theme="lac"
                                name={`promoters[${entry.id}][aadhaar]`}
                                onChange={(value) => { this.handleArrayFormValue('promoters', entry.id, 'aadhaar', value); }}
                                value={entry.aadhaar}
                              />
                            </td>
                            <td>
                              <BizInput
                                theme="lac"
                                name={`promoters[${entry.id}][dob]`}
                                onChange={(value) => { this.handleArrayFormValue('promoters', entry.id, 'dob', value); }}
                                value={entry.dob}
                              />
                            </td>
                            <td>
                              <BizInput
                                type="textarea"
                                theme="lac"
                                name={`promoters[${entry.id}][address]`}
                                onChange={(value) => { this.handleArrayFormValue('promoters', entry.id, 'address', value); }}
                                value={entry.address}
                              />
                            </td>
                            <td>
                              <BizInput
                                type="number"
                                theme="lac"
                                name={`promoters[${entry.id}][networth]`}
                                onChange={(value) => { this.handleArrayFormValue('promoters', entry.id, 'networth', value); }}
                                value={entry.networth}
                              />
                            </td>
                          </tr>
                        ))
                      }
                    </tbody>
                  </table>
                </td>
                <td className="biz-form-table-action" />
              </tr>
              {
                promoters.map((entry) => (
                  <tr key={entry.id}>
                    <td className="biz-form-table-label">Background of<br />{entry.name}</td>
                    <td className="biz-form-table-input">
                      <BizInput
                        type="textarea"
                        theme="lac"
                        name={`promoters[${entry.id}][background]`}
                        onChange={(value) => { this.handleArrayFormValue('promoters', entry.id, 'background', value); }}
                        value={entry.background}
                        style={{ width: '100%', height: 100, maxWidth: 'unset' }}
                      />
                    </td>
                    <td className="biz-form-table-action" />
                  </tr>
                ))
              }

              {/* **
              Group Background
            ** */}
              {
                group_name ?
                  <tr style={styles.sectionHeadRow}>
                    <td colSpan={3}><h5 style={styles.sectionHead}>Group Background</h5></td>
                  </tr>
                  :
                  null
              }
              {
                group_name ?
                  <tr>
                    <td className="biz-form-table-label">Group Background</td>
                    <td className="biz-form-table-input">
                      <BizInput
                        type="textarea"
                        theme="lac"
                        name="groupBackground"
                        onChange={(value) => { this.handleFormValue('groupBackground', value); }}
                        value={groupBackground}
                        style={{ width: '100%', height: 150, maxWidth: 'unset' }}
                      />
                    </td>
                    <td className="biz-form-table-action" />
                  </tr>
                  :
                  null
              }

              {/* **
              Project Background
            ** */}
              {
                details.new_project ?
                  <tr style={styles.sectionHeadRow}>
                    <td colSpan={3}><h5 style={styles.sectionHead}>Project Background</h5></td>
                  </tr>
                  :
                  null
              }
              {
                details.new_project ?
                  <tr>
                    <td className="biz-form-table-label">Project Background</td>
                    <td className="biz-form-table-input">
                      <BizInput
                        type="textarea"
                        theme="lac"
                        name="projectBackground"
                        onChange={(value) => { this.handleFormValue('projectBackground', value); }}
                        value={projectBackground}
                        style={{ width: '100%', height: 150, maxWidth: 'unset' }}
                      />
                    </td>
                    <td className="biz-form-table-action" />
                  </tr>
                  :
                  null
              }
              {
                details.new_project ?
                  <tr>
                    <td className="biz-form-table-label">Current Status of the Project</td>
                    <td className="biz-form-table-input">
                      <BizInput
                        type="textarea"
                        theme="lac"
                        name="projectCurrentStatus"
                        onChange={(value) => { this.handleFormValue('projectCurrentStatus', value); }}
                        value={projectCurrentStatus}
                        style={{ width: '100%', height: 150, maxWidth: 'unset' }}
                      />
                    </td>
                    <td className="biz-form-table-action" />
                  </tr>
                  :
                  null
              }
              {
                details.new_project ?
                  <tr>
                    <td className="biz-form-table-label">Project SWOT Analysis</td>
                    <td className="biz-form-table-input">
                      <BizInput
                        type="textarea"
                        theme="lac"
                        name="projectSwotAnalysis"
                        onChange={(value) => { this.handleFormValue('projectSwotAnalysis', value); }}
                        value={projectSwotAnalysis}
                        style={{ width: '100%', height: 150, maxWidth: 'unset' }}
                      />
                    </td>
                    <td className="biz-form-table-action" />
                  </tr>
                  :
                  null
              }

              {/* **
              Financial Summary
            ** */}
              <tr style={styles.sectionHeadRow}>
                <td colSpan={3}><h5 style={styles.sectionHead}>Financial Summary</h5></td>
              </tr>
              <tr>
                <td className="biz-form-table-label">Financial Summary</td>
                <td className="biz-form-table-input">
                  <table className="biz-data-table biz-bordered">
                    <thead>
                      <tr>
                        <th rowSpan={2}>Particulars</th>
                        <th>Mar-{currentYear - 3}</th>
                        <th>Mar-{currentYear - 2}</th>
                        <th>Mar-{currentYear - 1}</th>
                      </tr>
                      <tr>
                        <th>Aud.</th>
                        <th>Aud.</th>
                        <th>Aud.</th>
                      </tr>
                    </thead>
                    <tbody>
                      {
                        financialSummaryEntries.map((entry) => (
                          this.financialSummaryRow(entry)
                        ))
                      }
                    </tbody>
                  </table>
                </td>
                <td className="biz-form-table-action" />
              </tr>

              {/* **
              Current Bankers and Proposal
            ** */}
              <tr style={styles.sectionHeadRow}>
                <td colSpan={3}><h5 style={styles.sectionHead}>Current Bankers and Proposal</h5></td>
              </tr>
              {/* Current Exposure Chart */}
              <tr>
                <td className="biz-form-table-label">Current Exposure Chart</td>
                <td className="biz-form-table-input">
                  <table className="biz-data-table biz-bordered">
                    <thead>
                      <tr>
                        <th>Name of Bank</th>
                        <th>CC</th>
                        <th>TL</th>
                        <th>BG</th>
                        <th>LC</th>
                        <th>Other</th>
                        <th>Total</th>
                      </tr>
                    </thead>
                    <tbody>
                      {
                        present_banking_arrangements.map((pb) => (
                          <tr key={pb.id}>
                            <td>{pb.bank_name}</td>
                            <td>{currencyFormat(pb.sanction_cc)}</td>
                            <td>{currencyFormat(pb.sanction_tl)}</td>
                            <td>{currencyFormat(pb.sanction_lc)}</td>
                            <td>{currencyFormat(pb.sanction_bg)}</td>
                            <td>{currencyFormat(pb.sanction_other)}</td>
                            <td>
                              {currencyFormat(pb.sanction_tl + pb.sanction_cc + pb.sanction_bg + pb.sanction_lc + pb.sanction_other)}
                            </td>
                          </tr>
                        ))
                      }
                    </tbody>
                  </table>
                </td>
                <td className="biz-form-table-action" />
              </tr>
              {/* Proposed */}
              <tr>
                <td className="biz-form-table-label">Proposed Banking</td>
                <td className="biz-form-table-input">
                  <table className="biz-data-table biz-bordered">
                    <thead>
                      <tr>
                        <th>Name of Bank</th>
                        <th>CC</th>
                        <th>TL/LAP</th>
                        <th>BG</th>
                        <th>DOD</th>
                        <th>Pledge</th>
                        <th>Total</th>
                        <th />
                      </tr>
                    </thead>
                    <tbody>
                      {
                        proposedBanking.map((entry) => (
                          <tr key={entry.id}>
                            <td>
                              <BizInput
                                theme="lac"
                                name={`proposedBanking[${entry.id}][bank_name]`}
                                onChange={(value) => { this.handleArrayFormValue('proposedBanking', entry.id, 'bank_name', value); }}
                                value={entry.bank_name}
                              />
                            </td>
                            <td>
                              <BizInput
                                type="number"
                                theme="lac"
                                name={`proposedBanking[${entry.id}][cc]`}
                                onChange={(value) => { this.handleArrayFormValue('proposedBanking', entry.id, 'cc', value); }}
                                value={entry.cc}
                              />
                            </td>
                            <td>
                              <BizInput
                                type="number"
                                theme="lac"
                                name={`proposedBanking[${entry.id}][tl]`}
                                onChange={(value) => { this.handleArrayFormValue('proposedBanking', entry.id, 'tl', value); }}
                                value={entry.tl}
                              />
                            </td>
                            <td>
                              <BizInput
                                type="number"
                                theme="lac"
                                name={`proposedBanking[${entry.id}][bg]`}
                                onChange={(value) => { this.handleArrayFormValue('proposedBanking', entry.id, 'bg', value); }}
                                value={entry.bg}
                              />
                            </td>
                            <td>
                              <BizInput
                                type="number"
                                theme="lac"
                                name={`proposedBanking[${entry.id}][dod]`}
                                onChange={(value) => { this.handleArrayFormValue('proposedBanking', entry.id, 'dod', value); }}
                                value={entry.dod}
                              />
                            </td>
                            <td>
                              <BizInput
                                type="number"
                                theme="lac"
                                name={`proposedBanking[${entry.id}][pledge]`}
                                onChange={(value) => { this.handleArrayFormValue('proposedBanking', entry.id, 'pledge', value); }}
                                value={entry.pledge}
                              />
                            </td>
                            <td>
                              {currencyFormat(entry.cc + entry.tl + entry.bg + entry.dod + entry.pledge)}
                            </td>
                            <td>
                              <DeleteFormRowButton onClick={() => { this.removeFormRow('proposedBanking', entry.id); }} />
                            </td>
                          </tr>
                        ))
                      }
                    </tbody>
                  </table>
                </td>
                <td className="biz-form-table-action">
                  <Button
                    onClick={() => {
                      this.setState({
                        proposedBanking: [...proposedBanking, {
                          id: (+new Date()).toString(36),
                          bank_name: '',
                          cc: 0,
                          tl: 0,
                          bg: 0,
                          dod: 0,
                          pledge: 0,
                        }],
                      });
                    }}
                  >
                    Add new banker
                  </Button>
                </td>
              </tr>
              {/* Note */}
              <tr>
                <td className="biz-form-table-label">Notes</td>
                <td className="biz-form-table-input">
                  <BizInput
                    type="textarea"
                    theme="lac"
                    name="bankersNote"
                    onChange={(value) => { this.handleFormValue('bankersNote', value); }}
                    value={bankersNote}
                    style={{ width: '100%', height: 150, maxWidth: 'unset' }}
                  />
                </td>
                <td className="biz-form-table-action" />
              </tr>

              {/* **
              Security Offered
            ** */}
              <tr style={styles.sectionHeadRow}>
                <td colSpan={3}><h5 style={styles.sectionHead}>Security Offered</h5></td>
              </tr>
              {/* Primary - Immovable */}
              <tr>
                <td className="biz-form-table-label">Primary - Immovable</td>
                <td className="biz-form-table-input">
                  <table className="biz-data-table biz-bordered">
                    <thead>
                      <tr>
                        <th>Address</th>
                        <th>Property Type</th>
                        <th>Owned By</th>
                        <th>Plot Area</th>
                        <th>Construction Area</th>
                        <th>Market Value</th>
                        <th>Product</th>
                        <th>Nature of Charge</th>
                        <th />
                      </tr>
                    </thead>
                    <tbody>
                      {
                        securityPrimaryImmovable.map((entry) => (
                          <tr key={entry.id}>
                            <td>
                              <div>
                                <BizInput
                                  type="textarea"
                                  theme="lac"
                                  name={`securityPrimaryImmovable[${entry.id}][address]`}
                                  onChange={(value) => { this.handleArrayFormValue('securityPrimaryImmovable', entry.id, 'address', value); }}
                                  value={entry.address}
                                  placeholder="Street Address"
                                />
                              </div>
                              <div>
                                <BizInput
                                  theme="lac"
                                  name={`securityPrimaryImmovable[${entry.id}][city]`}
                                  onChange={(value) => { this.handleArrayFormValue('securityPrimaryImmovable', entry.id, 'city', value); }}
                                  value={entry.city}
                                  placeholder="City"
                                />
                              </div>
                              <div>
                                <BizInput
                                  theme="lac"
                                  name={`securityPrimaryImmovable[${entry.id}][state]`}
                                  onChange={(value) => { this.handleArrayFormValue('securityPrimaryImmovable', entry.id, 'state', value); }}
                                  value={entry.state}
                                  placeholder="State"
                                />
                              </div>
                              <div>
                                <BizInput
                                  theme="lac"
                                  name={`securityPrimaryImmovable[${entry.id}][pincode]`}
                                  onChange={(value) => { this.handleArrayFormValue('securityPrimaryImmovable', entry.id, 'pincode', value); }}
                                  value={entry.pincode}
                                  placeholder="Pincode"
                                />
                              </div>
                            </td>
                            <td>
                              <BizInput
                                theme="lac"
                                name={`securityPrimaryImmovable[${entry.id}][property_type]`}
                                onChange={(value) => { this.handleArrayFormValue('securityPrimaryImmovable', entry.id, 'property_type', value); }}
                                value={entry.property_type}
                              />
                            </td>
                            <td>
                              <BizInput
                                theme="lac"
                                name={`securityPrimaryImmovable[${entry.id}][owned_by]`}
                                onChange={(value) => { this.handleArrayFormValue('securityPrimaryImmovable', entry.id, 'owned_by', value); }}
                                value={entry.owned_by}
                              />
                            </td>
                            <td>
                              <BizInput
                                type="number"
                                theme="lac"
                                name={`securityPrimaryImmovable[${entry.id}][plot_area]`}
                                onChange={(value) => { this.handleArrayFormValue('securityPrimaryImmovable', entry.id, 'plot_area', value); }}
                                value={entry.plot_area}
                              />
                            </td>
                            <td>
                              <BizInput
                                type="number"
                                theme="lac"
                                name={`securityPrimaryImmovable[${entry.id}][construction_area]`}
                                onChange={(value) => { this.handleArrayFormValue('securityPrimaryImmovable', entry.id, 'construction_area', value); }}
                                value={entry.construction_area}
                              />
                            </td>
                            <td>
                              <BizInput
                                type="number"
                                theme="lac"
                                name={`securityPrimaryImmovable[${entry.id}][market_value]`}
                                onChange={(value) => { this.handleArrayFormValue('securityPrimaryImmovable', entry.id, 'market_value', value); }}
                                value={entry.market_value}
                              />
                            </td>
                            <td>
                              <BizInput
                                theme="lac"
                                name={`securityPrimaryImmovable[${entry.id}][product]`}
                                onChange={(value) => { this.handleArrayFormValue('securityPrimaryImmovable', entry.id, 'product', value); }}
                                value={entry.product}
                              />
                            </td>
                            <td>
                              <BizSelect
                                name={`securityPrimaryImmovable[${entry.id}][charge_nature]`}
                                onChange={(value) => { this.handleArrayFormValue('securityPrimaryImmovable', entry.id, 'charge_nature', value); }}
                                value={entry.charge_nature}
                                options={natureOfChargeOptions}
                                theme="lac"
                              />
                            </td>
                            <td>
                              <DeleteFormRowButton onClick={() => { this.removeFormRow('securityPrimaryImmovable', entry.id); }} />
                            </td>
                          </tr>
                        ))
                      }
                    </tbody>
                  </table>
                </td>
                <td className="biz-form-table-action">
                  <Button
                    onClick={() => {
                      this.setState({
                        securityPrimaryImmovable: [...securityPrimaryImmovable, {
                          id: (+new Date()).toString(36),
                          address: '',
                          city: '',
                          state: '',
                          pincode: '',
                          property_type: '',
                          owned_by: '',
                          plot_area: 0,
                          construction_area: 0,
                          market_value: 0,
                          product: '',
                          charge_nature: null,
                        }],
                      });
                    }}
                  >
                    Add new
                  </Button>
                </td>
              </tr>

              {/* Primary - Movable */}
              <tr>
                <td className="biz-form-table-label">Primary - Movable</td>
                <td className="biz-form-table-input">
                  <table className="biz-data-table biz-bordered">
                    <thead>
                      <tr>
                        <th>Particulars</th>
                        <th>Market Value</th>
                        <th>Product</th>
                        <th>Nature of Charge</th>
                        <th />
                      </tr>
                    </thead>
                    <tbody>
                      {
                        securityPrimaryMovable.map((entry) => (
                          <tr key={entry.id}>
                            <td>
                              <BizInput
                                type="textarea"
                                textareaRows={2}
                                theme="lac"
                                name={`securityPrimaryMovable[${entry.id}][details]`}
                                onChange={(value) => { this.handleArrayFormValue('securityPrimaryMovable', entry.id, 'details', value); }}
                                value={entry.details}
                              />
                            </td>
                            <td>
                              <BizInput
                                type="number"
                                theme="lac"
                                name={`securityPrimaryMovable[${entry.id}][market_value]`}
                                onChange={(value) => { this.handleArrayFormValue('securityPrimaryMovable', entry.id, 'market_value', value); }}
                                value={entry.market_value}
                              />
                            </td>
                            <td>
                              <BizInput
                                theme="lac"
                                name={`securityPrimaryMovable[${entry.id}][product]`}
                                onChange={(value) => { this.handleArrayFormValue('securityPrimaryMovable', entry.id, 'product', value); }}
                                value={entry.product}
                              />
                            </td>
                            <td>
                              <BizSelect
                                name={`securityPrimaryMovable[${entry.id}][charge_nature]`}
                                onChange={(value) => { this.handleArrayFormValue('securityPrimaryMovable', entry.id, 'charge_nature', value); }}
                                value={entry.charge_nature}
                                options={natureOfChargeOptions}
                                theme="lac"
                              />
                            </td>
                            <td>
                              <DeleteFormRowButton onClick={() => { this.removeFormRow('securityPrimaryMovable', entry.id); }} />
                            </td>
                          </tr>
                        ))
                      }
                    </tbody>
                  </table>
                </td>
                <td className="biz-form-table-action">
                  <Button
                    onClick={() => {
                      this.setState({
                        securityPrimaryMovable: [...securityPrimaryMovable, {
                          id: (+new Date()).toString(36),
                          details: '',
                          market_value: 0,
                          product: '',
                          charge_nature: null,
                        }],
                      });
                    }}
                  >
                    Add new
                  </Button>
                </td>
              </tr>
              {/* Collateral - Immovable */}
              <tr>
                <td className="biz-form-table-label">Collateral - Immovable</td>
                <td className="biz-form-table-input">
                  <table className="biz-data-table biz-bordered">
                    <thead>
                      <tr>
                        <th>Address</th>
                        <th>Property Type</th>
                        <th>Owned By</th>
                        <th>Plot Area</th>
                        <th>Construction Area</th>
                        <th>Market Value</th>
                        <th>Product</th>
                        <th>Nature of Charge</th>
                        <th />
                      </tr>
                    </thead>
                    <tbody>
                      {
                        securityCollateralImmovable.map((entry) => (
                          <tr key={entry.id}>
                            <td>
                              <div>
                                <BizInput
                                  type="textarea"
                                  theme="lac"
                                  name={`securityCollateralImmovable[${entry.id}][address]`}
                                  onChange={(value) => { this.handleArrayFormValue('securityCollateralImmovable', entry.id, 'address', value); }}
                                  value={entry.address}
                                  placeholder="Street Address"
                                />
                              </div>
                              <div>
                                <BizInput
                                  theme="lac"
                                  name={`securityCollateralImmovable[${entry.id}][city]`}
                                  onChange={(value) => { this.handleArrayFormValue('securityCollateralImmovable', entry.id, 'city', value); }}
                                  value={entry.city}
                                  placeholder="City"
                                />
                              </div>
                              <div>
                                <BizInput
                                  theme="lac"
                                  name={`securityCollateralImmovable[${entry.id}][state]`}
                                  onChange={(value) => { this.handleArrayFormValue('securityCollateralImmovable', entry.id, 'state', value); }}
                                  value={entry.state}
                                  placeholder="State"
                                />
                              </div>
                              <div>
                                <BizInput
                                  theme="lac"
                                  name={`securityCollateralImmovable[${entry.id}][pincode]`}
                                  onChange={(value) => { this.handleArrayFormValue('securityCollateralImmovable', entry.id, 'pincode', value); }}
                                  value={entry.pincode}
                                  placeholder="Pincode"
                                />
                              </div>
                            </td>
                            <td>
                              <BizInput
                                theme="lac"
                                name={`securityCollateralImmovable[${entry.id}][property_type]`}
                                onChange={(value) => { this.handleArrayFormValue('securityCollateralImmovable', entry.id, 'property_type', value); }}
                                value={entry.property_type}
                              />
                            </td>
                            <td>
                              <BizInput
                                theme="lac"
                                name={`securityCollateralImmovable[${entry.id}][owned_by]`}
                                onChange={(value) => { this.handleArrayFormValue('securityCollateralImmovable', entry.id, 'owned_by', value); }}
                                value={entry.owned_by}
                              />
                            </td>
                            <td>
                              <BizInput
                                type="number"
                                theme="lac"
                                name={`securityCollateralImmovable[${entry.id}][plot_area]`}
                                onChange={(value) => { this.handleArrayFormValue('securityCollateralImmovable', entry.id, 'plot_area', value); }}
                                value={entry.plot_area}
                              />
                            </td>
                            <td>
                              <BizInput
                                type="number"
                                theme="lac"
                                name={`securityCollateralImmovable[${entry.id}][construction_area]`}
                                onChange={(value) => { this.handleArrayFormValue('securityCollateralImmovable', entry.id, 'construction_area', value); }}
                                value={entry.construction_area}
                              />
                            </td>
                            <td>
                              <BizInput
                                type="number"
                                theme="lac"
                                name={`securityCollateralImmovable[${entry.id}][market_value]`}
                                onChange={(value) => { this.handleArrayFormValue('securityCollateralImmovable', entry.id, 'market_value', value); }}
                                value={entry.market_value}
                              />
                            </td>
                            <td>
                              <BizInput
                                theme="lac"
                                name={`securityCollateralImmovable[${entry.id}][product]`}
                                onChange={(value) => { this.handleArrayFormValue('securityCollateralImmovable', entry.id, 'product', value); }}
                                value={entry.product}
                              />
                            </td>
                            <td>
                              <BizSelect
                                name={`securityCollateralImmovable[${entry.id}][charge_nature]`}
                                onChange={(value) => { this.handleArrayFormValue('securityCollateralImmovable', entry.id, 'charge_nature', value); }}
                                value={entry.charge_nature}
                                options={natureOfChargeOptions}
                                theme="lac"
                              />
                            </td>
                            <td>
                              <DeleteFormRowButton onClick={() => { this.removeFormRow('securityCollateralImmovable', entry.id); }} />
                            </td>
                          </tr>
                        ))
                      }
                    </tbody>
                  </table>
                </td>
                <td className="biz-form-table-action">
                  <Button
                    onClick={() => {
                      this.setState({
                        securityCollateralImmovable: [...securityCollateralImmovable, {
                          id: (+new Date()).toString(36),
                          address: '',
                          city: '',
                          state: '',
                          pincode: '',
                          property_type: '',
                          owned_by: '',
                          plot_area: 0,
                          construction_area: 0,
                          market_value: 0,
                          product: '',
                          charge_nature: null,
                        }],
                      });
                    }}
                  >
                    Add new
                  </Button>
                </td>
              </tr>

              {/* Collateral - Movable */}
              <tr>
                <td className="biz-form-table-label">Collateral - Movable</td>
                <td className="biz-form-table-input">
                  <table className="biz-data-table biz-bordered">
                    <thead>
                      <tr>
                        <th>Particulars</th>
                        <th>Market Value</th>
                        <th>Product</th>
                        <th>Nature of Charge</th>
                        <th />
                      </tr>
                    </thead>
                    <tbody>
                      {
                        securityCollateralMovable.map((entry) => (
                          <tr key={entry.id}>
                            <td>
                              <BizInput
                                type="textarea"
                                textareaRows={2}
                                theme="lac"
                                name={`securityCollateralMovable[${entry.id}][details]`}
                                onChange={(value) => { this.handleArrayFormValue('securityCollateralMovable', entry.id, 'details', value); }}
                                value={entry.details}
                              />
                            </td>
                            <td>
                              <BizInput
                                type="number"
                                theme="lac"
                                name={`securityCollateralMovable[${entry.id}][market_value]`}
                                onChange={(value) => { this.handleArrayFormValue('securityCollateralMovable', entry.id, 'market_value', value); }}
                                value={entry.market_value}
                              />
                            </td>
                            <td>
                              <BizInput
                                theme="lac"
                                name={`securityCollateralMovable[${entry.id}][product]`}
                                onChange={(value) => { this.handleArrayFormValue('securityCollateralMovable', entry.id, 'product', value); }}
                                value={entry.product}
                              />
                            </td>
                            <td>
                              <BizSelect
                                name={`securityCollateralMovable[${entry.id}][charge_nature]`}
                                onChange={(value) => { this.handleArrayFormValue('securityCollateralMovable', entry.id, 'charge_nature', value); }}
                                value={entry.charge_nature}
                                options={natureOfChargeOptions}
                                theme="lac"
                              />
                            </td>
                            <td>
                              <DeleteFormRowButton onClick={() => { this.removeFormRow('securityCollateralMovable', entry.id); }} />
                            </td>
                          </tr>
                        ))
                      }
                    </tbody>
                  </table>
                </td>
                <td className="biz-form-table-action">
                  <Button
                    onClick={() => {
                      this.setState({
                        securityCollateralMovable: [...securityCollateralMovable, {
                          id: (+new Date()).toString(36),
                          details: '',
                          market_value: 0,
                          product: '',
                          charge_nature: null,
                        }],
                      });
                    }}
                  >
                    Add new
                  </Button>
                </td>
              </tr>

              <tr>
                <td className="biz-form-table-label" />
                <td colSpan={2}>
                  <MuiButton variant="raised" color="primary" style={{ margin: '5px 0' }}>
                    Submit
                  </MuiButton>
                </td>
              </tr>

            </tbody>
          </table>
        </BizCard>
      </div>
    );
  }
}

FactsheetCreate.getDerivedStateFromProps = (nextProps) => {
  const { loading, createFactsheetData } = nextProps.data;
  if (!loading && createFactsheetData) {
    const newState = {
      companyName: createFactsheetData.name,
    };
    for (let i = 0; i < createFactsheetData.addresses.length; i++) {
      const address = createFactsheetData.addresses[i];
      if (address.type === 'Registered') {
        newState.registeredAddress = `${address.address}, ${address.city}, ${address.state} - ${address.pincode}`;
      }
      if (address.type === 'Factory') {
        newState.factoryAddress = `${address.address}, ${address.city}, ${address.state} - ${address.pincode}`;
      }
    }

    if (createFactsheetData.management_persons.length > 0) {
      newState.promoters = createFactsheetData.management_persons.map((entry) => ({
        id: entry.id,
        name: `${entry.first_name} ${entry.middle_name} ${entry.last_name}`,
        qualifications: '',
        pan: '',
        aadhaar: '',
        dob: '',
        address: '',
        networth: 0,
        background: '',
      }));
    }

    return newState;
  }
  return null;
};

FactsheetCreate.propTypes = {
  match: PropTypes.shape({
    params: PropTypes.shape({
      id: PropTypes.string.isRequired,
    }),
  }).isRequired,
  data: PropTypes.shape({
    loading: PropTypes.bool.isRequired,
    createFactsheetData: PropTypes.object,
  }).isRequired,
};

export default graphql(createFactsheetDataQuery, {
  options: ({ match }) => ({ variables: { customer_id: match.params.id } }),
})(FactsheetCreate);



// WEBPACK FOOTER //
// ./src/pages/factsheet/FactsheetCreate.jsx